import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TrackRotation } from '@tsin-core/models/rotations.model';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';

const ROTATION_URL = `${environment.apiUrl}/rotations`;
const TRACK_URL = `${environment.apiUrl}/tracks`;
const STATION_URL = `${environment.apiUrl}/stations`;
// /api/rotations/examId/{examId}
@Injectable({
  providedIn: 'root'
})
export class RotationService {

  private http: HttpClient = inject(HttpClient);

  generateStations(examId: string): Observable<any> {
    return this.http.patch<any>(`${ROTATION_URL}/generate-rotations/${examId}`, examId);
  }

  getRotations(examId: string): Observable<any> {
    return this.http.get<any>(`${ROTATION_URL}/exam/${examId}`);
  }

  getRotationStations(stationId: string): Observable<any> {
    return this.http.get<any>(`${ROTATION_URL}/station/${stationId}`);
  }


  getRotationStationsByExam(examId: string): Observable<any> {
    return this.http.get<any>(`${STATION_URL}/exam/${examId}`);
  }

  getRotationsTrack(trackId: string): Observable<TrackRotation> {
    return this.http.get<TrackRotation>(`${ROTATION_URL}/track/${trackId}`);
  }


  getStationsByTrack(trackId: string): Observable<any> {
    return this.http.get<any>(`${STATION_URL}/track/${trackId}`);
  }

  getRotationsTracks(examId: string): Observable<any> {
    return this.http.get<any>(`${TRACK_URL}/exam/${examId}`);
  }

  getRotationsByStation(stationId: string): Observable<any> {
    return this.http.get<any>(`${ROTATION_URL}/station/${stationId}`);
  }

  addNewRotation(payload: { examId: string, stationId: string, applicationId: string, }) {
    return this.http.post(`${ROTATION_URL}`, payload);
  }


}
